var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "client-single client-view-single" }, [
    _c("div", { staticClass: "m-content" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 col-lg-6" }, [
          _c("div", { staticClass: "m-portlet m-portlet--mobile" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "m-portlet__body" }, [
              _c(
                "table",
                {
                  staticClass:
                    "table table-striped- table-bordered table-hover table-checkable",
                  attrs: { id: "inquiry-table" }
                },
                [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.projectArr, function(project, key) {
                      return _c("tr", [
                        _c("td", [
                          _vm._v(_vm._s(project.client_project_count))
                        ]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(project.created))]),
                        _vm._v(" "),
                        _c("td", [
                          project.current_status_id < 2
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "m-badge  m-badge--danger m-badge--wide"
                                },
                                [_vm._v("Briefing erstellen")]
                              )
                            : project.current_status_id == 3
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "m-badge  m-badge--brand m-badge--wide"
                                },
                                [_vm._v("Fotografie")]
                              )
                            : project.current_status_id == 4
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "m-badge  m-badge--metal m-badge--wide"
                                },
                                [_vm._v("Bildbearbeitung")]
                              )
                            : project.current_status_id < 6
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "m-badge  m-badge--info m-badge--wide"
                                },
                                [_vm._v("Kontrolle")]
                              )
                            : _c(
                                "span",
                                {
                                  staticClass:
                                    "m-badge  m-badge--default m-badge--wide"
                                },
                                [_vm._v("Abgeschlossen")]
                              )
                        ]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(project.name))]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "a",
                            {
                              staticClass:
                                "m-badge  m-badge--warning m-badge--wide",
                              attrs: { href: "projekt-" + project.id }
                            },
                            [_vm._v("Details")]
                          )
                        ])
                      ])
                    }),
                    0
                  )
                ]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-lg-6" }, [
          _c("div", { staticClass: "m-portlet  m-portlet--full-height " }, [
            _vm._m(2),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "m-portlet__body" },
              [_c("timeline", { attrs: { "timeline-arr": _vm.timelineArr } })],
              1
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-portlet__head" }, [
      _c("div", { staticClass: "m-portlet__head-caption" }, [
        _c("div", { staticClass: "m-portlet__head-title" }, [
          _c("h3", { staticClass: "m-portlet__head-text" }, [
            _vm._v(
              "\n                                    Anfragen\n                                "
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", { attrs: { role: "row" } }, [
        _c("th", { staticClass: "sorting_asc" }, [_vm._v("Auftrags Nr.")]),
        _vm._v(" "),
        _c("th", { staticClass: "sorting" }, [_vm._v("Erstellt am")]),
        _vm._v(" "),
        _c("th", { staticClass: "sorting" }, [_vm._v("Aktueller Status")]),
        _vm._v(" "),
        _c("th", { staticClass: "sorting" }, [_vm._v("Projekt")]),
        _vm._v(" "),
        _c("th", { staticClass: "sorting" }, [_vm._v("Aktionen")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-portlet__head" }, [
      _c("div", { staticClass: "m-portlet__head-caption" }, [
        _c("div", { staticClass: "m-portlet__head-title" }, [
          _c("h3", { staticClass: "m-portlet__head-text" }, [
            _vm._v(
              "\n                                    Verlauf Ihrer Projekte\n                                "
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }